import React from 'react';
import cn from 'clsx';
import { string, bool } from 'prop-types';
import { designTokenPropTypes } from '@immediate_media/design-tokens';
import Link from '../../atoms/Link/index.jsx';
import { useDesignTokens } from '../../hooks/index.js';

/**
 * LinkBox component.
 */
const LinkBox = ({
  text,
  url,
  prefix,
  hasFlag,
  className,
  bgColor,
  color,
  rel,
  target,
  large
}) => {
  const {
    colors
  } = useDesignTokens();
  const hasBgColour = !!(bgColor && colors[bgColor]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('link-box', className, large ? 'link-box--large' : 'body-copy-small', hasBgColour && hasFlag && 'link-box--flag'),
    style: {
      backgroundColor: bgColor === 'inherit' ? 'inherit' : colors[bgColor],
      color: hasBgColour ? colors[color] : null
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: hasBgColour ? large ? 'pt-xxs pb-xxs pl-xs pr-xs' : 'pl-xxs pr-xxs' : ""
  }, prefix && `${prefix} `, url ? /*#__PURE__*/React.createElement(Link, {
    styled: !hasBgColour,
    rel: rel,
    className: "link-box__link",
    href: url,
    target: target
  }, text) : text));
};
LinkBox.defaultProps = {
  url: null,
  prefix: null,
  hasFlag: false,
  className: null,
  bgColor: 'inherit',
  color: null,
  rel: null,
  target: null,
  large: false
};
LinkBox.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The link text. */
  text: string.isRequired,
  /** The link url. */
  url: string,
  /** Optional prefix for the link. */
  prefix: string,
  /** Optional flag shape on the right-side for the link. */
  hasFlag: bool,
  /** Additional class names to add to the component root. */
  className: string,
  /** The background colour of the box. */
  bgColor: designTokenPropTypes.color,
  /** The text color to be applied if a bgColor is given. */
  color: designTokenPropTypes.color,
  /** The relationship between the current document and the linked document. */
  rel: string,
  /** Where to open the linked document. */
  target: string,
  /** Use large text. */
  large: bool
} : {};
export default LinkBox;